export const rsRoads = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "SITE CLEARANCE & EARTHWORKS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Flail scrub",
    Qty: "6456",
    Unit: "m²",
    Rate: "0.45",
    Amount: "£2,905.20",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "6456",
    Unit: "m²",
    Rate: "1.25",
    Amount: "£8,070.00",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 334mm top soil, deposit onsite",
    Qty: "2156",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£10,909.36",
  },
  {
    Item: "",
    Description:
      "Remove fencing, bollards etc to facilitate construction of roads and sewers",
    Qty: "1",
    Unit: "item",
    Rate: "1500.00",
    Amount: "£1,500.00",
  },
  {
    Item: "",
    Description: "Remove hedges to facilitate roads and sewers",
    Qty: "1",
    Unit: "item",
    Rate: "4968.00",
    Amount: "£4,968.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "EXCAVATING & FILLING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "1185",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£5,996.10",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil to paths",
    Qty: "4510",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£32,111.20",
  },
  {
    Item: "",
    Description: "Filling with suitable site won material to roads",
    Qty: "2532",
    Unit: "m³",
    Rate: "25.34",
    Amount: "£64,160.88",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Level and compact formation",
    Qty: "15566",
    Unit: "m²",
    Rate: "0.83",
    Amount: "£12,919.78",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "CARRIAGEWAY ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.1",
    Description: "Macadam Internal Development Road",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "350mm thick Recycled 6F2 capping layer",
    Qty: "8258",
    Unit: "m²",
    Rate: "17.74",
    Amount: "£146,496.92",
  },
  {
    Item: "",
    Description: "150mm thick MOT Type 1",
    Qty: "8258",
    Unit: "m²",
    Rate: "12.46",
    Amount: "£102,894.68",
  },
  {
    Item: "",
    Description: "130mm thick AC 32mm DBM base course",
    Qty: "6827",
    Unit: "m²",
    Rate: "37.70",
    Amount: "£257,377.90",
  },
  {
    Item: "",
    Description: "60mm thick AC 20mm DBM binder course",
    Qty: "6827",
    Unit: "m²",
    Rate: "17.40",
    Amount: "£118,789.80",
  },
  {
    Item: "",
    Description: "Sealing grit",
    Qty: "6827",
    Unit: "m²",
    Rate: "0.73",
    Amount: "£4,983.71",
  },
  {
    Item: "",
    Description: "Sweep tack",
    Qty: "6827",
    Unit: "m²",
    Rate: "1.05",
    Amount: "£7,168.35",
  },
  {
    Item: "",
    Description: "40mm thick HRA 55/14C (n ex psv60) surface course",
    Qty: "6827",
    Unit: "m²",
    Rate: "18.26",
    Amount: "£124,661.02",
  },
  {
    Item: "",
    Description: "EO form joint to existing carriageway",
    Qty: "18",
    Unit: "m",
    Rate: "43.72",
    Amount: "£786.96",
  },
  {
    Item: "",
    Description:
      "EO form carriageway with limited mechanical plant due to to tree canopy",
    Qty: "180",
    Unit: "m²",
    Rate: "85.43",
    Amount: "£15,377.40",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.3",
    Description: "Block Paved Internal Development Road",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "350mm thick Recycled 6F2 capping layer",
    Qty: "1438",
    Unit: "m²",
    Rate: "17.74",
    Amount: "£25,510.12",
  },
  {
    Item: "",
    Description: "150mm thick MOT Type 1",
    Qty: "1438",
    Unit: "m²",
    Rate: "12.46",
    Amount: "£17,917.48",
  },
  {
    Item: "",
    Description: "135mm thick AC 32mm DBM base course",
    Qty: "1189",
    Unit: "m²",
    Rate: "39.14",
    Amount: "£46,537.46",
  },
  {
    Item: "",
    Description: "60mm thick AC 20mm DBM binder course",
    Qty: "1189",
    Unit: "m²",
    Rate: "17.40",
    Amount: "£20,688.60",
  },
  {
    Item: "",
    Description: "Sealing grit",
    Qty: "1189",
    Unit: "m²",
    Rate: "0.73",
    Amount: "£867.97",
  },
  {
    Item: "",
    Description: "Sweep",
    Qty: "1189",
    Unit: "m²",
    Rate: "0.37",
    Amount: "£439.93",
  },
  {
    Item: "",
    Description: "200 x 100 x 80mm block paviour on 35mm sand bed",
    Qty: "1189",
    Unit: "m²",
    Rate: "47.95",
    Amount: "£57,012.55",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO retrofit ramp in delineation from macadam to block paved",
    Qty: "20",
    Unit: "nr",
    Rate: "1206.00",
    Amount: "£24,120.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.0",
    Description: "FOOTPATHS, VEHICLE CROSSOVERS & VERGES ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.1",
    Description: "Tarmac Footpath",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "150mm thick MOT Type 1",
    Qty: "4355",
    Unit: "m²",
    Rate: "12.46",
    Amount: "£54,263.30",
  },
  {
    Item: "",
    Description: "100mm thick AC 32mm DBM binder course",
    Qty: "4355",
    Unit: "m²",
    Rate: "41.16",
    Amount: "£179,251.80",
  },
  {
    Item: "",
    Description: "60mm thick AC 20mm DBM binder course",
    Qty: "4355",
    Unit: "m²",
    Rate: "24.70",
    Amount: "£107,568.50",
  },
  {
    Item: "",
    Description: "Sweep tack ",
    Qty: "4355",
    Unit: "m²",
    Rate: "1.05",
    Amount: "£4,572.75",
  },
  {
    Item: "",
    Description: "25mm thick AC 6mm DBM surface course",
    Qty: "4355",
    Unit: "m²",
    Rate: "17.34",
    Amount: "£75,515.70",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£1,536,343.42",
  },
  {
    Item: "",
    Description: "M & J EVANS CONSTRUCTION LIMITED",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "FAR MOOR LANE, REDDITCH",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "S38 WORKS TO ACHIEVE 3%+ CBR",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "Item",
    Description: "Description",
    Qty: "Qty",
    Unit: "Unit",
    Rate: "Rate",
    Amount: "Amount",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.2",
    Description: "Tarmac Crossover",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "200mm thick MOT Type 1",
    Qty: "1265",
    Unit: "m²",
    Rate: "16.61",
    Amount: "£21,011.65",
  },
  {
    Item: "",
    Description: "100mm thick AC 32mm DBM binder course",
    Qty: "1265",
    Unit: "m²",
    Rate: "41.16",
    Amount: "£52,067.40",
  },
  {
    Item: "",
    Description: "50mm thick AC 20mm DBM binder course",
    Qty: "1265",
    Unit: "m²",
    Rate: "24.70",
    Amount: "£31,245.50",
  },
  {
    Item: "",
    Description: "Sweep tack ",
    Qty: "1265",
    Unit: "m²",
    Rate: "1.05",
    Amount: "£1,328.25",
  },
  {
    Item: "",
    Description: "25mm thick AC 6mm DBM surface course",
    Qty: "1265",
    Unit: "m²",
    Rate: "17.34",
    Amount: "£21,935.10",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.3",
    Description: "Verges",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "250",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£715.00",
  },
  {
    Item: "",
    Description: "EO for bodpave verge reinforcement - Usual WCC spec",
    Qty: "250",
    Unit: "m²",
    Rate: "45.96",
    Amount: "£11,490.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.4",
    Description: "Public Right of Way Footpath (Permanent)",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Break out existing path",
    Qty: "175",
    Unit: "m²",
    Rate: "9.55",
    Amount: "£1,671.25",
  },
  {
    Item: "",
    Description: "Break out edgings",
    Qty: "355",
    Unit: "m",
    Rate: "5.03",
    Amount: "£1,785.65",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil to paths",
    Qty: "15",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£106.80",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "150mm thick MOT Type 1",
    Qty: "48",
    Unit: "m²",
    Rate: "12.46",
    Amount: "£598.08",
  },
  {
    Item: "",
    Description: "100mm thick AC 32mm DBM binder course",
    Qty: "48",
    Unit: "m²",
    Rate: "41.16",
    Amount: "£1,975.68",
  },
  {
    Item: "",
    Description: "60mm thick AC 20mm DBM binder course",
    Qty: "48",
    Unit: "m²",
    Rate: "24.70",
    Amount: "£1,185.60",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Plane existing surface course n/e 25mm",
    Qty: "355",
    Unit: "m²",
    Rate: "4.04",
    Amount: "£1,434.20",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Sweep tack ",
    Qty: "403",
    Unit: "m²",
    Rate: "1.05",
    Amount: "£423.15",
  },
  {
    Item: "",
    Description: "25mm thick AC 6mm DBM surface course",
    Qty: "403",
    Unit: "m²",
    Rate: "17.34",
    Amount: "£6,988.02",
  },
  {
    Item: "",
    Description: "Regulate path n/e 10mm",
    Qty: "355",
    Unit: "m²",
    Rate: "4.33",
    Amount: "£1,537.15",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "150 x 50 pcc edging",
    Qty: "355",
    Unit: "m",
    Rate: "21.77",
    Amount: "£7,728.35",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "5.0",
    Description: "KERBS & EDGINGS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Pcc Kerbs - All Sizes",
    Qty: "2869",
    Unit: "m",
    Rate: "64.06",
    Amount: "£183,788.14",
  },
  {
    Item: "",
    Description:
      "EO - Dowel bars to kerb race @ Drop kerbs - usual WCC spec, if required",
    Qty: "356",
    Unit: "nr",
    Rate: "4.77",
    Amount: "£1,698.12",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Temporary macadam fillet to drive crossover prior to road surfacing",
    Qty: "633",
    Unit: "m",
    Rate: "8.96",
    Amount: "£5,671.68",
  },
  {
    Item: "",
    Description: "Remove macadam fillet upon completion",
    Qty: "633",
    Unit: "m",
    Rate: "6.40",
    Amount: "£4,051.20",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "150 x 50 pcc edging",
    Qty: "3285",
    Unit: "m",
    Rate: "21.77",
    Amount: "£71,514.45",
  },
  {
    Item: "",
    Description:
      "EO 200 x 50mm edgings to back of vehicular crossover - usual WCC spec",
    Qty: "633",
    Unit: "m",
    Rate: "6.40",
    Amount: "£4,051.20",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Tactiles",
    Qty: "20",
    Unit: "nr",
    Rate: "495.54",
    Amount: "£9,910.80",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "6.0",
    Description: "ADJUST IRONWORK PRIOR TO FINAL SURFACING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Manholes",
    Qty: "88",
    Unit: "nr",
    Rate: "145.73",
    Amount: "£12,824.24",
  },
  {
    Item: "",
    Description: "Gully covers and frames",
    Qty: "166",
    Unit: "nr",
    Rate: "110.55",
    Amount: "£18,351.30",
  },
  {
    Item: "",
    Description:
      "Stop Tap Boxes                                               ",
    Qty: "236",
    Unit: "nr",
    Rate: "55.28",
    Amount: "£13,046.08",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "7.0",
    Description: "WHITE LINING",
    Qty: "1",
    Unit: "item",
    Rate: "4680.79",
    Amount: "£4,680.79",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "8.0",
    Description: "FIX-ONLY STREET NAMEPLATES",
    Qty: "27",
    Unit: "nr",
    Rate: "208.04",
    Amount: "£5,617.08",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "9.0",
    Description: "TREE PITS, BOLLARDS & STREET FURNITURE",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "10.0",
    Description: "REMEDIALS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£500,431.91",
  },
];
